import { mergePikPlusDataToInitialState } from 'shared/mappers/mergePikPlusDataToInitialState';
import { getSpecialProjectsBlocks } from 'shared/services/specialPromosBlocks';
import { type ITypedReduxAction } from 'shared/types/redux/actionType';
import { type TThunkAction } from 'shared/types/redux/thunk';
import { type ISpecialPromosBlocks } from 'shared/types/specialPromosBlocks';

export enum ESpecialPromosBlocksTypes {
  ESpecialPromosBlocksRefresh = 'SPECIAL_PROMOS_BLOCKS/REFRESH',
}

export type TSpecialPromosBlocksRefresh = ITypedReduxAction<
  ESpecialPromosBlocksTypes.ESpecialPromosBlocksRefresh,
  ISpecialPromosBlocks
>;

export function specialPromosBlocksRefresh(locationId: number): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    try {
      const state = getState();
      const {
        banksPik,
        newbuildingsPlusBlocksPik,
        phone,
        mortgageBannerPik,
        mortgageCalculatorPik,
        developerRatings,
        developerAwards,
        facts,
      } = await getSpecialProjectsBlocks(context, locationId);

      mergePikPlusDataToInitialState(state, newbuildingsPlusBlocksPik);

      dispatch({
        payload: {
          banks: banksPik,
          developerAwards,
          developerRatings,
          facts,
          mortgageBanner: mortgageBannerPik,
          mortgageCalculator: mortgageCalculatorPik,
          newbuildingsPlusBlocksPik,
          phone,
        },
        type: ESpecialPromosBlocksTypes.ESpecialPromosBlocksRefresh,
      });
    } catch (error) {
      console.error(error);
    }
  };
}
